import type { CalendarEvent } from '../types';

interface RawTimeEntryEvent {
  id: string;
  description: string;
  startedAt: string; // ISO string
  durationSeconds: number; // always integer — never float
}

type EventAdapter<TRaw> = (items: TRaw[]) => CalendarEvent[];

export const timeEntryAdapter: EventAdapter<RawTimeEntryEvent> = (items) =>
  items.map((item) => {
    const start = new Date(item.startedAt);
    const end = new Date(start.getTime() + item.durationSeconds * 1000);

    return {
      id: item.id,
      title: item.description,
      start,
      end,
      allDay: false,
      type: 'time-entry',
      source: 'internal',
      metadata: { startedAt: item.startedAt, durationSeconds: item.durationSeconds },
    };
  });
